const { Strength } = require('sma.common/strength');
const DatePicker = require('sma.admin/components/datepicker');

class Registration {
	static determineTimezone() {
		const tz = jstz.determine();

		if (tz) {
			$('#id_timezone').val(tz.name());
		}
	}

	constructor() {
		Registration.determineTimezone();

		/* eslint-disable no-new */
		new Strength({
			element: $('#id_password'),
			confirm: $('#id_confirm_password'),
		});

		$('.sma-js-date-picker').each((index, input) => {
			new DatePicker(input);
		});
		/* eslint-enable no-new */
	}
}

module.exports = Registration;
